import { createAction as actionCreatorFactory } from 'redux-actions';

export const SET_PLATFORM = 'vdk/platform/SET_PLATFORM';

export const setPlatform = actionCreatorFactory(SET_PLATFORM);